import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { GridOptions } from 'ag-grid-community';
import { CeqTableComponent } from '../../common/ceq-table/ceq-table.component';
import { MultiselectOption } from '../../common/ceq-multiselect/ceq-multiselect.component';

import { BalanceResume, MultichannelService } from '../multichannel.service';
import { EquipmentloanserviceService } from '../../self-service/equipment-loan/equipmentloanservice.service';
import { CeveByContainerService } from '../../catalog/ceve/ceveByContainer.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { ContainerService } from '../../catalog/container/container/container.service';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { CeveService } from '../../catalog/ceve/ceve.service';

import { Container } from '../../common/models/Container.Model';
import { Channel } from '../../common/models/Channel.Model';
import { Route } from '../../common/models/Route.Model';
import { Unit } from '../../common/models/Unit.Model';

interface ContainerLine {
  Org: number;
  RoteId: number;
  ContainerId: number;
  ContainerCode: string;
  BalanceDate: string;
  InitialBalance: number;
  Load: number;
  AdjustUp: number;
  AdjustDown: number;
  ContainerReturn: number;
  SellerPaybill: number;
  PaybillRecovery: number;
  SellerRecovery: number;
  UnControlled: number;
  EarlyDelivery: number;
  DeliveryToReceipt: number;
  PendingPaybill: number;
  EquipmenLoan: number;
  FinalBalance: number;
  ControlBalance: number;
  IntegratedInventory: number;
  AdjustPaybill: number;
  AdjustRecovery: number;
}

@Component({
  selector: 'app-route-balance',
  templateUrl: './route-balance.component.html',
  styleUrls: ['./route-balance.component.scss']
})
export class RouteBalanceComponent implements OnInit {

  constructor(
    private multichannelSerice: MultichannelService,
    private settings: SettingsService,
    private globalService: GlobalFunctionsService,
    private equipmentLoanService: EquipmentloanserviceService,
    private containerService: ContainerService,
    private ceveByContainerService: CeveByContainerService,
    private ceveService: CeveService,
  ) { }

  @ViewChild('ceqGrid', { static: false }) ceqGrid: CeqTableComponent;
  ceqListOptions: GridOptions;

  listOptions = {
    context: this,
    // suppressHorizontalScroll: true,
    // onRowDoubleClicked(event: any): any { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  };

  columnDefs = [
    {
      field: 'ContainerId',
      hide: true,
      sort: 'asc',
      suppressSizeToFit: true
    },
    {
      headerName: 'Equipo',
      field: 'ContainerCode',
      cellStyle: { background: '#A0CFEC', color: 'darkblue', 'text-align': 'center', border: '1px solid gray' },
      width: 150,
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      suppressSizeToFit: true,
      pinned: 'left'
    },
    {
      headerName: '+ Inventario inicial',
      field: 'InitialBalance',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#C6DEFF', color: 'blue', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '+ Cargo',
      field: 'Load',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '+ Ajuste de carga',
      field: 'AdjustUp',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Ajuste de carga',
      field: 'AdjustDown',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Entrega Adelantada',
      field: 'EarlyDelivery',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Devolución vendedor',
      field: 'ContainerReturn',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Vale compulsa',
      field: 'AdjustPaybill',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '+ Sobrante de compulsa',
      field: 'AdjustRecovery',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Equipo no controlado',
      field: 'UnControlled',
      width: 150,
      cellStyle: { background: '#C6DEFF', color: 'blue', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: 'Existencia en camión CEQ',
      field: 'FinalBalance',
      width: 150,
      cellStyle: { background: '#98FF98', color: 'green', 'text-align': 'end', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: 'Cifra de control',
      field: 'ControlBalance',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FFFFC2', color: 'brown', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '- Vale',
      field: 'SellerPaybill',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FFFFC2', color: 'brown', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '+ Recuperación de vale',
      field: 'PaybillRecovery',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FFFFC2', color: 'brown', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: '+ Recuperación de vendedor',
      field: 'SellerRecovery',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FFFFC2', color: 'brown', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
      // cellRenderer: (params: any) =>
      //   (params.data.PendingPaybill - params.data.SellerPaybill) ,
    },
    {
      headerName: 'Vales pendientes',
      field: 'PendingPaybill',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FDD7E4', color: 'red', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: 'Comodato',
      field: 'EquipmenLoan',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FDD7E4', color: 'red', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },
    {
      headerName: 'Inventario Integrado',
      field: 'IntegratedInventory',
      width: 150,
      cellStyle: { 'text-align': 'end', background: '#FDD7E4', color: 'red', border: '1px solid gray' },
      editable: false,
      resizable: true,
      suppressSizeToFit: true
    },

  ];

  working: boolean = false;
  resume: BalanceResume = new BalanceResume();
  resalta: boolean = false;
  validation: number = 0;
  charging: boolean = false;
  canGetCargo: boolean = false;
  enableCargo: boolean = true;

  //filters
  routeBalanceReportActivitty: boolean = false;
  selectedDate: string;
  currentDate: Date;
  currentSelectedDate: Date;
  maxDate: string;

  selectedUnit: Unit = undefined;
  ceveCode: string = '';
  channels: Channel[] = [];
  channelId = undefined;
  routes: Route[] = [];
  routeId = undefined;
  routeCode: string = undefined;
  containers: Container[] = [];
  containerTypeList: MultiselectOption[] = [];
  selectedcontainers: number[] = this.containerTypeList.map(x => x.Id);
  asChannelCode: string = '561';
  activities: string[];
  customerListGridData: ContainerLine[] = [];
  customerBalance: any[];

  listEmiter(gridOptions: GridOptions): void {
    this.ceqListOptions = gridOptions;
    this.ceqGrid.gridOptions = this.ceqListOptions;
    this.ceqGrid.gridOptions.api.hideOverlay();
  }

  ngOnInit(): void {
    let userActivities = this.settings.getUserAccess();
    this.routeBalanceReportActivitty = userActivities.includes('REPMULTICH');
    this.selectedDate = this.globalService.getStringDate(new Date(), false, 0);
    this.maxDate = this.globalService.getStringDate(new Date(), true, -2);
    this.currentDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.currentSelectedDate = moment(this.selectedDate).toDate();
    this.activities = this.settings.getUserAccess();
    console.log(this.currentSelectedDate, this.currentDate);
    if (this.activities.includes("GETCARGO")) {
      if (moment(this.currentSelectedDate).isSame(this.currentDate, 'day')) {
        this.canGetCargo = true;
      } else {
        this.canGetCargo = false;
      }
    }
  }

  onUnitClear() {
    this.selectedUnit = undefined;
    this.channels = [];
    this.channelId = undefined;
    this.routes = [];
    this.routeId = undefined;
    this.routeCode = undefined;
    this.containerTypeList = [];
    this.selectedcontainers = [];

    this.ceqGrid.data = [];
  }

  async onUnitSelected(event: Unit) {
    this.selectedUnit = event;
    this.ceveCode = event.UnitCode;
    //getContainers must be before getChannelsByCeve to ensure grid dato is displayed when the page is showed
    await this.getContainers();
    await this.getChannelsByCeve();
    await this.getRoutesByChannel();
    this.refresh();
  }

  async onChannelSelected(event: any) {
    await this.getRoutesByChannel();
  }

  async onRouteSelected(event: any) {
    this.routeCode = this.routes.find(x => x.RouteId == this.routeId).RouteCode;
    await this.GetRouteBalance();
  }

  async onDateSelected() {
    console.log(this.currentSelectedDate, this.currentDate);
    this.currentSelectedDate = moment(this.selectedDate).toDate();
    if (moment(this.currentSelectedDate).isSame(this.currentDate, 'day')) {
      this.canGetCargo = true;
    } else {
      this.canGetCargo = false;
    }
    this.GetRouteBalanceResume();
    await this.GetRouteBalance();
  }

  async getChannelsByCeve() {
    this.working = true;

    await this.ceveService.getChannelsbyCeve(this.selectedUnit.UnitId)
      .toPromise()
      .then(data => {
        this.working = false;
        this.channels = data.filter(x => x.ChannelCode != this.asChannelCode).map(x => { return { UnitId: x.UnitId, ChannelCode: x.ChannelCode, ChannelName: x.ChannelName } });
        if (this.channels.length > 0) {
          this.channelId = this.channels[0].UnitId;
          this.onChannelSelected(this.channelId);
        }
      })
      .catch(async (error) => {
        this.working = false;
        console.error(error);
        await this.globalService.messageToast(error.error.Message, 'error');
      });

  }

  async getRoutesByChannel() {
    if (this.channelId == null || this.channelId == undefined) {
      return;
    }

    this.working = true;
    this.equipmentLoanService.getRoutesByChannel(this.selectedUnit.UnitId, this.channelId)
      .toPromise()
      .then(async resp => {
        this.working = false;
        this.routes = resp;
        if (this.routes.length > 0) {
          this.routeId = resp[0].RouteId;
          this.routeCode = resp[0].RouteCode;
          this.GetRouteBalance();
        }
      })
      .catch(async (error) => {
        this.working = false;
        console.error(error);
        await this.globalService.messageToast(error.error.Message, 'error');
      });
  }

  async getContainers() {
    this.working = true;
    await this.containerService.getContainersByContainerOrg(this.settings.getUser().Org, 0, 0)
      .toPromise()
      .then(async resp => {
        this.working = false;
        let tmpContainers = resp.map(x => { return { Checked: false, Id: x.ContainerId, Text: x.ContainerCode } });
        if (resp.length > 0) {
          //Consulto el equipo configurado por defecto
          let initialContainers = await this.getInitialContainers();
          //si no hay equipo configurado por defecto, selecciono todos el equipo
          if (initialContainers.length == 0) {
            initialContainers = tmpContainers.map(x => x.Id);
          }
          initialContainers.forEach(item => {
            let c = tmpContainers.find(x => x.Id == item);
            if (c != undefined && c != null) {
              c.Checked = true;
            }
          })

          this.containers = resp;
          this.containerTypeList = tmpContainers;
          this.selectedcontainers = this.containerTypeList.filter(x => x.Checked == true).map(x => x.Id);
        }
      })
      .catch(async error => {
        this.working = false;
        console.error(error);
        await this.globalService.messageToast(error.error.Message, 'error');
      })
  }

  async getInitialContainers(): Promise<number[]> {
    let containerIds: number[] = [];
    await this.ceveByContainerService.getCheckedRouteBalanceContainers(this.selectedUnit.UnitId)
      .toPromise()
      .then(resp => {
        containerIds = resp;
      })
      .catch(err => {
        console.error(err);
      });
    return new Promise(resolve => resolve(containerIds));
  }

  async ContainerSelected() {
    await this.GetRouteBalance();
  }

  /**Se ejecuta cuando se desenfoca la lista desplegable de equipo  */
  async onRemissionTypeFilterChange(event: MultiselectOption[]) {

    this.selectedcontainers = event.map(x => x.Id);
    await this.GetRouteBalance();
  }

  /**se ejecuta cuando se selecciona un equipo de la lista desplegable */
  onRemissionTypeItemCheckedChange(event: MultiselectOption) {
    //
  }


  async GetRouteBalance() {
    //si no hay canales ni rutas seleccionadas, salgo 
    if (this.channelId == null || this.channelId == undefined) {
      return;
    }
    if (this.routeId == null || this.routeId == undefined) {
      return;
    }
    if (this.selectedDate == null || this.selectedDate == undefined || this.selectedDate == '') {
      this.globalService.messageToast('Debe seleccionar una fecha', 'warning');
      return;
    }

    this.working = true;
    this.ceqGrid.gridOptions.api.showLoadingOverlay();
    await this.multichannelSerice.getRouteBalance(this.selectedUnit.UnitId, this.channelId, this.routeId, this.selectedcontainers, this.selectedDate)
      .toPromise()
      .then(async resp => {
        this.working = false;
        if (resp.length == 0) {
          this.customerListGridData = [];
          this.containers.map(cnt => this.createContainerLine(cnt.ContainerId, cnt.ContainerCode, true));
          console.log(this.customerListGridData);
          this.ceqGrid.data = this.customerListGridData;
        } else {
          console.log(resp);
          this.ceqGrid.data = resp;
        }

        this.ceqGrid.gridOptions.api.hideOverlay();
      })
      .catch(async error => {
        this.working = false;
        this.ceqGrid.gridOptions.api.hideOverlay();
        console.error(error);
        await this.globalService.messageToast(error.error.Message, 'error');
      });
  }

  createContainerLine(containerId: number, containerCode: string, toZero: boolean = false): void {
    if (toZero) {
      const line: ContainerLine = {
        Org: 1,
        RoteId: this.routeId,
        ContainerId: containerId,
        ContainerCode: containerCode,
        BalanceDate: this.selectedDate,
        InitialBalance: 0,
        Load: 0,
        AdjustUp: 0,
        AdjustDown: 0,
        ContainerReturn: 0,
        SellerPaybill: 0,
        PaybillRecovery: 0,
        SellerRecovery: 0,
        UnControlled: 0,
        EarlyDelivery: 0,
        DeliveryToReceipt: 0,
        PendingPaybill: 0,
        EquipmenLoan: 0,
        FinalBalance: 0,
        ControlBalance: 0,
        IntegratedInventory: 0,
        AdjustPaybill: 0,
        AdjustRecovery: 0,
      };
      this.customerListGridData.push(line);
      return;
    }

  }

  checkZero(containerLine: ContainerLine): number {
    let sum = 0;
    for (const el in containerLine) {
      if (containerLine[el] > 0) {
        sum += Number(containerLine[el]);
      }
    }
    return sum;
  }

  async GetRouteBalanceResume() {
    this.working = true;
    await this.multichannelSerice.getRouteBalanceResume(this.selectedUnit.UnitId, this.selectedDate)
      .toPromise()
      .then(async resp => {
        this.resume = resp;

        // 19-MAY-2025
        // Anteriormtente se realizaba un calculo previo a las compulsas para los escenarios de devolucion mayor a la existencia.
        // se agrego un candado en la app mobil para no debolver mas de la existencia, por este cambio ya no es necesaria la operacion previa a las compulsas
        // y el calculo del saldo final se realiza de la siguiente manera 
        this.validation=this.resume.inventario_dia_anterior
          + this.resume.cargo
          + this.resume.ajuste_cargo
          - this.resume.entrega_adelantada_total
          - this.resume.devolucion_total
          - this.resume.no_controlado
          + this.resume.sobrante_compulsa
          - this.resume.vale_compulsa;

        this.validation = this.validation < 0 ? 0 : this.validation;

        if ((this.validation - this.resume.saldo_final_total) != 0)
          this.resalta = true;
        else
          this.resalta = false;

        this.getLoadData();
        this.working = false;
      })
      .catch(async error => {
        this.working = false;
        console.error(error);
        await this.globalService.messageToast(error.error.Message, 'error');
      });
  }

  // Obtiene los datos de carga de las rutas
  async getLoadData() {
    await this.multichannelSerice.getRouteDataLoad(this.selectedUnit.UnitId, this.selectedDate).toPromise().then(resp => {
      if (resp.Data.length > 0) {
        this.enableCargo = resp.HasCargos;
      } else {
        this.enableCargo = false;
      }
    });
  }

  // Se obtienen los cargos de forma manual
  async getCharge() {
    this.charging = true;
    this.multichannelSerice.getChargeRoutes(this.selectedUnit.UnitId, this.selectedDate).subscribe(async resp => {
      console.log(resp);
      if (resp != null && resp != undefined) {
        this.charging = false;
        this.enableCargo = true;
        await this.GetRouteBalanceResume();
        await this.getChannelsByCeve();
        this.globalService.messageToast('Datos cargados correctamente', 'success');
      } else {
        this.enableCargo = false;
        this.charging = false;
        this.globalService.messageToast('Aún no están disponibles los cargos.', 'warning');
      }
    }, (error) => {
      this.enableCargo = false;
      this.charging = false;
      this.globalService.messageToast('Error al obtener los cargos', 'error');
    });
  }

  async refresh() {
    await this.GetRouteBalanceResume();
    await this.GetRouteBalance();
  }

}